










export default {
  name: 'LangChip',
  props: {
    voiceLanguage: { type: String, default: '' },
    dark: { type: Boolean, default: false },
    isInner: { type: Boolean, default: false }
  },
  computed: {
    shortLabel(): string {
      const lang = this.voiceLanguage;
      if (!lang) return '';
      return lang.slice(0, 3);
    },
    chipColor(): string {
      return this.dark ? 'rgba(255,255,255,.28)' : '#e0e0e0';
    },
    chipStyle(): Record<string, string> {
      return {
        fontWeight: '400',
        color: this.dark ? '#fff' : 'rgba(0,0,0,.87)'
      };
    }
  }
};
